import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { useApp } from "@/context/AppContext";

export function Seo({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} — Zeta Clinic` : "Zeta Clinic | İstanbul";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description || "İstanbul'da dijital gülüş tasarımı ve kişiye özel zirkonyum tedavisi.";
  }, [title, description]);
  return null;
}

export function SectionTag({ children }) {
  return <span className="section-label inline-block mb-4">{children}</span>;
}

export function PageHeader({ tag, title, subtitle }) {
  const { t } = useApp();
  const reduce = useReducedMotion();
  return (
    <motion.header
      className="pt-36 pb-14 px-6 md:px-12 max-w-6xl mx-auto"
      initial={reduce ? false : { opacity: 0, y: 24 }}
      animate={reduce ? undefined : { opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    >
      {tag && <SectionTag>{t(tag)}</SectionTag>}
      <h1 className="display-lg text-[#F2F5F7] max-w-3xl">{t(title)}</h1>
      {subtitle && <p className="mt-6 text-base md:text-lg text-[#94A3AE] max-w-2xl leading-relaxed">{t(subtitle)}</p>}
    </motion.header>
  );
}

export function CtaLink({ to, children, testId, variant = "solid", onClick, href }) {
  const cls = variant === "solid" ? "cta-primary" : "cta-ghost";
  if (href)
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId} onClick={onClick}>
        {children}
      </a>
    );
  return (
    <Link to={to} className={cls} data-testid={testId} onClick={onClick}>
      {children}
    </Link>
  );
}

export function SimDisclaimer() {
  const { t } = useApp();
  return (
    <p className="text-xs text-[#7C8B97] italic mt-3" data-testid="sim-disclaimer">
      {t({
        tr: "Dijital görselleştirme temsilidir. Nihai tedavi planı ve uygunluk, diş hekiminin klinik değerlendirmesi sonucunda belirlenir.",
        en: "Digital visualisation is representative. The final treatment plan and suitability are determined by the dentist's clinical evaluation.",
      })}
    </p>
  );
}
